var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "mapDiv", staticClass: "search-map" },
    [
      _c(
        "gmap-map",
        {
          ref: "gmap",
          staticStyle: { width: "100%", height: "100%" },
          attrs: { center: _vm.center, zoom: 12, options: _vm.options }
        },
        _vm._l(_vm.markers, function(marker, index) {
          return _c("gmap-marker", {
            key: index,
            attrs: {
              icon: _vm.getMarkerIcon(marker, index),
              label: marker.label ? marker.label : null,
              position: marker.position,
              clickable: true
            },
            on: {
              mouseover: function($event) {
                return _vm.changeMarker(marker, "hover")
              },
              mouseout: function($event) {
                return _vm.changeMarker(marker, "out")
              },
              click: function($event) {
                return _vm.scrollToProfessional(marker)
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc3b85bc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc3b85bc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ProfessionalMap.vue
// module id = 1882
// module chunks = 0